"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppPage = exports.EditEntityForm = void 0;
const FormEditor_1 = require("@juvare/common-form-ui/FormEditor");
const AppPageHeader2_1 = require("@juvare/common-web-ui/AppPageHeader2");
const DialogHelper_1 = require("@juvare/common-web-ui/DialogHelper");
const LayoutRows3_1 = require("@juvare/common-web-ui/LayoutRows3");
const NavigationContext_1 = require("@juvare/common-web-ui/NavigationContext");
const PageError_1 = require("@juvare/common-web-ui/PageError");
const SnackbarHelper_1 = require("@juvare/common-web-ui/SnackbarHelper");
const hooks_1 = require("../../../../../../ui/hooks");
const usePlatformSdkReactTranslation_1 = require("../../../../../../ui/hooks/usePlatformSdkReactTranslation");
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const react_router_1 = require("react-router");
function EditEntityForm(props) {
    var _a, _b, _c;
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    const navigationContext = react_1.default.useContext(NavigationContext_1.NavigationContext);
    react_1.default.useEffect(() => {
        return navigationContext.cleanUp;
    }, [navigationContext]);
    const navigate = (0, react_router_1.useNavigate)();
    const location = (0, react_router_1.useLocation)();
    const { id } = (0, react_router_1.useParams)();
    const storage = (0, hooks_1.useStorageClient)(props.entity);
    const { data, isLoading, error } = (0, hooks_1.useStorageGet)(props.entity, id);
    if (error) {
        return react_1.default.createElement(PageError_1.PageError, { error: error });
    }
    if (isLoading || !data) {
        return react_1.default.createElement(material_1.CircularProgress, null);
    }
    return (react_1.default.createElement(exports.AppPage, { header: react_1.default.createElement(AppPageHeader2_1.AppPageHeader2, { title: props.title, subTitle: props.getEntityTitle(data), onBack: () => navigationContext.navigate(() => { var _a; return (((_a = location.state) === null || _a === void 0 ? void 0 : _a.back) ? navigate(-1) : navigate('..')); }) }) },
        react_1.default.createElement(FormEditor_1.FormEditor, { config: ((_a = data.data.form) !== null && _a !== void 0 ? _a : emptyForm), toolbarButtons: ((_b = data.data.default) === null || _b === void 0 ? void 0 : _b.form)
                ? [
                    {
                        label: t('classifiers.resetToDefault'),
                        onClick: (config, setConfig) => (0, DialogHelper_1.showConfirmDialog)({
                            title: t('classifiers.resetFormToDefaultState'),
                            onConfirm: () => {
                                var _a, _b;
                                setConfig((_b = (_a = data.data.default) === null || _a === void 0 ? void 0 : _a.form) !== null && _b !== void 0 ? _b : emptyForm);
                            },
                        }),
                    },
                ]
                : undefined, onChanged: (changed, save) => {
                if (changed) {
                    navigationContext.setChanged(t('classifiers.saveChanges'), save);
                }
                else {
                    navigationContext.clearChanged();
                }
            }, onSave: (config) => {
                navigationContext.save(storage
                    .post({
                    action: 'partial-update',
                    id: data.id,
                    data: props.onFormSubmit
                        ? props.onFormSubmit(config, data)
                        : {
                            form: config,
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        },
                })
                    .then(() => {
                    var _a;
                    (0, SnackbarHelper_1.showInfoSnackbar)({ message: t('common.itemSaved', { item: props.title }) });
                    if ((_a = location.state) === null || _a === void 0 ? void 0 : _a.back) {
                        navigate(-1);
                    }
                    else {
                        navigate({
                            pathname: '..',
                            search: new URLSearchParams({ id: data.id }).toString(),
                        }, {});
                    }
                })
                    .catch(DialogHelper_1.handleErrorDialog));
            }, initialPreviewState: !!((_c = location.state) === null || _c === void 0 ? void 0 : _c.preview) })));
}
exports.EditEntityForm = EditEntityForm;
const emptyForm = {
    type: 'form',
    children: [],
};
const AppPage = (props) => {
    return (react_1.default.createElement(LayoutRows3_1.LayoutRows3, { row1: props.header, row2: react_1.default.createElement(material_1.Box, { sx: {
                boxSizing: 'border-box',
                height: props.contentScrollable ? undefined : '100%',
                p: {
                    xs: 0,
                    md: 2,
                },
            } },
            react_1.default.createElement(material_1.Box, { sx: {
                    boxSizing: 'border-box',
                    width: props.contentWidth ? getContentWidth(props.contentWidth) : undefined,
                    height: props.contentScrollable ? undefined : '100%',
                    margin: props.contentWidth ? 'auto' : undefined,
                    padding: (theme) => (props.contentPadding ? theme.spacing(props.contentPadding) : 0),
                } }, props.children)), row3: props.footer, fullHeightRow: 'row2', row1Scrollable: true, row2Scrollable: props.contentScrollable }));
};
exports.AppPage = AppPage;
function getContentWidth(contentWidth) {
    return typeof contentWidth === 'string' ? `min(100vw, ${contentWidth})` : `min(100vw, ${contentWidth}px)`;
}
